import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { jwtDecode } from 'jwt-decode';
import DashboardNavbar from '../components/Navbar/navbar-dashboard';
import PersonIcon from '../../src/images/home-landing-page/person-icon.png'
import AccreditationIcon from '../../src/images/home-landing-page/accreditation-icon.png'
import ContactIcon from '../../src/images/home-landing-page/contact-icon.png'
import Footer from '../components/Footer/footer';
import { useNavigate } from 'react-router-dom';
import showToast from '../components/ShowToast';
import Swal from 'sweetalert2';
import Loader from '../components/Loader';
import '../styles/interests.css';
import '../styles/onboarding.css';

const OnboardingStep15 = () =>
{
  const [constructionInterests, setConstructionInterests] = useState([]);
  const [personalInterests, setPersonalInterests] = useState([]);
  const [selectedConstructionInterests, setSelectedConstructionInterests] = useState([]);
  const [selectedPersonalInterests, setSelectedPersonalInterests] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [personalInterestError, setPersonalInterestError] = useState(null);
  const [constructionInterestError, setContructionInterestError] = useState(null);
  const navigate = useNavigate();

  useEffect(() =>
  {
    // Fetch construction interests
    const fetchConstructionInterests = async () =>
    {
      try
      {
        const response = await axios.get(`${API_BASE_URL}/api/HomeOnboarding/constructioninterests`);
        setConstructionInterests(response.data);
      } catch (error)
      {
        setError("Error fetching construction interests");
      }
    };

    const fetchPersonalInterests = async () =>
    {
      try
      {
        const response = await axios.get(`${API_BASE_URL}/api/HomeOnboarding/personalinterests`);
        setPersonalInterests(response.data);
      } catch (error)
      {
        setError("Error fetching personal interests");
      }
    };

    fetchConstructionInterests();
    fetchPersonalInterests();
  }, []);

  // Handle checkbox changes for construction interests
  const handleConstructionChange = (id) =>
  {
    setSelectedConstructionInterests((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((cId) => cId !== id)
        : [...prevSelected, id]
    );
  };

  // Handle checkbox changes for personal interests
  const handlePersonalChange = (id) =>
  {
    setSelectedPersonalInterests((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((pId) => pId !== id)
        : [...prevSelected, id]
    );
  };

  const handleSubmit = async () =>
  {
    try
    {

      if (selectedConstructionInterests.length > 0 && selectedPersonalInterests.length > 0)
      {
        setLoading(true);
        const userId = jwtDecode(localStorage.getItem('token')).nameid;
        await axios.post(`${API_BASE_URL}/api/HomeOnboarding/saveConstructionInterests`, {
          userId: userId,
          cinterestIds: selectedConstructionInterests,
        });

        await axios.post(`${API_BASE_URL}/api/HomeOnboarding/savePersonalInterests`, {
          userId: userId,
          pinterestIds: selectedPersonalInterests,
        });
        const parseUserId = parseInt(userId)
        var response = await axios.get(`${API_BASE_URL}/api/HomeUsers/updateOnboarding?userId=${parseUserId}`);
        var data = response.data.model;
        if (data.onboardingStatus)
        {
          Swal.fire({
            title: "🎉 Congratulations!",
            text: "You've successfully completed the onboarding process! We're thrilled to have you on board. 🎊",
            icon: "success",
            confirmButtonText: "Start Exploring",
            customClass:
              "confirmation-popup"
          });
          if (data.profilePic)
            sessionStorage.setItem('userImage', data.profilePic);
          navigate('/newhome');
        }
      }
      else
      {
        if (selectedPersonalInterests.length === 0)
          setPersonalInterestError("Please select a personal interest");
        if (selectedConstructionInterests.length === 0)
          setContructionInterestError("Please select a construction interest");
      }
    } catch (error)
    {
      showToast('error', error.response.model.message.join(' '));
    }
    setLoading(false);
  };

  return (
    <div className="home-onboarding-three">
      <DashboardNavbar prefix={''} />
      {loading ? <Loader /> : null}
      {error && <div className="error-message">{error}</div>}
      <section class="inner-page-banner text-center">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <h1>TELL US A BIT ABOUT YOURSELF</h1>
              <p>We will contact you to help in your service</p>
              <div class="banner-stepper">
                <div class="step complete">
                  <span class="step-icon">
                    <img src={PersonIcon} />
                  </span>
                  <span class="step-text">Tell us about your locality</span>
                </div>
                <div class="step complete">
                  <span class="step-icon">
                    <img src={ContactIcon} />
                  </span>
                  <span class="step-text">How can we contact you?</span>
                </div>
                <div class="step current">
                  <span class="step-icon">
                    <img src={AccreditationIcon} />
                  </span>
                  <span class="step-text">What accreditation do you have?</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="onboarding-form ">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">

              <div class="form-main">
                <div class="form-row">
                  <div className="form-group">
                    <label>Construction Interests</label>
                    <div className="form-control-wrapper checkbox-grid">

                      {constructionInterests.map((interest) =>
                      {
                        const checkboxId = `construction-${interest.cInterestId}`; // Create a unique ID for each checkbox
                        return (
                          <div key={interest.cInterestId} className='check-box'>
                            <input
                              type="checkbox"
                              id={checkboxId} // Set the ID of the checkbox
                              checked={selectedConstructionInterests.includes(interest.cInterestId)}
                              onChange={() => handleConstructionChange(interest.cInterestId)}
                            />
                            <label htmlFor={checkboxId}>{interest.interestName}</label> {/* Link label to input using htmlFor */}
                          </div>
                        );
                      })}

                    </div>
                    {selectedConstructionInterests.length === 0 && (constructionInterestError && <span className="error">{constructionInterestError}</span>)}
                  </div>
                </div>
              </div>

              <div class="form-main">
                <div class="form-row">
                  <div className="form-group">
                    <label>Personal Interests</label>
                    <div className="form-control-wrapper checkbox-grid">
                      {personalInterests.map((interest) =>
                      {
                        const checkboxId = `personal-${interest.pInterestId}`; // Create a unique ID for each checkbox
                        return (
                          <div key={interest.pInterestId} className='check-box'>
                            <input
                              type="checkbox"
                              id={checkboxId} // Set the ID of the checkbox
                              checked={selectedPersonalInterests.includes(interest.pInterestId)}
                              onChange={() => handlePersonalChange(interest.pInterestId)}
                            />
                            <label htmlFor={checkboxId}>{interest.interestName}</label> {/* Link label to input using htmlFor */}
                          </div>
                        );
                      })}
                    </div>
                    {selectedPersonalInterests.length === 0 && (personalInterestError && <span className="error">{personalInterestError}</span>)}
                  </div>
                </div>
              </div>
              <div class="onboarding-form-button">
                <button onClick={handleSubmit}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default OnboardingStep15;